export const SEARCH_FOR_SECURITIES_PLACEHOLDER = 'Search for Securities';
